export default __webpack_public_path__ + "static/grey-black-cork-ee6481f5be4a79fa16fbddc02cfd5f9e.png";